export const SET_AUTOMARKET_DATA = 'SET_AUTOMARKET_DATA';
export const SET_AUTOMARKET_ACTIVE_CATEGORY = 'SET_AUTOMARKET_ACTIVE_CATEGORY';
export const SET_AUTOMARKET_CATEGORIES = "SET_AUTOMARKET_CATEGORIES";
export const SET_AUTOMARKET_PRODUCTS = "SET_AUTOMARKET_PRODUCTS";

